import { IGeneralMessageCustomer, IStudent } from '../models/pushMessage.model';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IPushMessageState {
  content: string;
  customers: IGeneralMessageCustomer[];
  students: IStudent[];
}

const initialState: IPushMessageState = {
  content: '',
  customers: [],
  students: [],
};

const pushMessageSlicer = createSlice({
  name: 'pushMesage',
  initialState,
  reducers: {
    setCustomers: (
      state: IPushMessageState,
      action: PayloadAction<Pick<IPushMessageState, 'content' | 'customers'>>,
    ) => {
      state.content = action.payload.content;
      state.customers = action.payload.customers;
    },
    setStudents: (
      state: IPushMessageState,
      action: PayloadAction<Pick<IPushMessageState, 'content' | 'students'>>,
    ) => {
      state.content = action.payload.content;
      state.students = action.payload.students;
    },
  },
});

export const { setCustomers, setStudents } = pushMessageSlicer.actions;

export default pushMessageSlicer.reducer;
